// extracted by mini-css-extract-plugin
var _1 = "TextareaPlaceholder-moduleplaceholder__OYvXl";
var _2 = "TextareaPlaceholder-moduleplaceholderBox__SV3ib";
var _3 = "TextareaPlaceholder-modulerequired__HBT4n";
var _4 = "TextareaPlaceholder-modulerequiredIcon__XLM4p IconNG-moduleiconContainer__SxWZ0";
export { _1 as "placeholder", _2 as "placeholderBox", _3 as "required", _4 as "requiredIcon" }
